module.exports = __webpack_public_path__ + "media/video_demo.0f50af91.mp4";